import { rwPassengersData } from '../../entities/rw-passengers-data';

const toUpperCaseTransformer = (value: string) => value.toUpperCase();

const commonMasks = {
  iin: {
    mask: '############',
  },
  fin: {
    mask: 'FFFFFFF',
    tokens: {
      F: {
        pattern: /[a-zA-Z0-9]/,
        optional: true,
        transform: toUpperCaseTransformer,
      },
    },
  },
  date: {
    mask: '##.##.####',
  },
  series: {
    mask: 'SS',
    tokens: {
      S: {
        pattern: /[a-zA-Z0-9]/,
        optional: true,
        transform: toUpperCaseTransformer,
      },
    },
  },
  /**
   * Prevent removing +7 because no need to use other country codes.
   * @see {contactsStore.state} for more details
   * */
  phoneNumber: {
    mask: '+7 ### ### ## ##',
  },
  email: {
    mask: 'E',
    tokens: {
      E: {
        pattern: /[a-zA-Z0-9@._-]/,
        multiple: true,
      },
    },
  },
};

export const aviaMasksOptions = {
  ...commonMasks,
  documentNumber: {
    mask: 'A',
    tokens: {
      A: {
        pattern: /[а-яА-Яa-zA-Z0-9]/,
        multiple: true,
        transform: toUpperCaseTransformer,
      },
    },
  },
  initials: {
    mask: 'A',
    tokens: {
      A: {
        pattern: /[a-zA-Z- ]/,
        multiple: true,
        transform: toUpperCaseTransformer,
      },
    },
  },
};

export const railwaysMasksOptions = {
  ...commonMasks,
  initials: {
    mask: 'A',
    tokens: {
      A: {
        pattern: /\*?/,
        multiple: true,
        transform: toUpperCaseTransformer,
      },
    },
  },
  iin: {
    mask: '############',
  },
  getDocumentNumber: (documentType: string) => {
    let mask: string;

    switch (documentType) {
      case rwPassengersData.config.documentTypes.ID:
        mask = '#########';
        break;
      case rwPassengersData.config.documentTypes.BIRTH_CERT:
        mask = 'N';
        break;
      case rwPassengersData.config.documentTypes.PASSPORT_KZ:
        mask = '!N########';
        break;
      default:
        mask = 'A';
        break;
    }

    return {
      mask,
      tokens: {
        A: {
          pattern: /[а-яА-Яa-zA-Z0-9]/,
          multiple: true,
          transform: toUpperCaseTransformer,
        },
        N: {
          pattern: /[0-9]/,
          multiple: true,
        },
      },
    };
  },
};
